module.exports = "<p>\n  produtos-arquivados works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/produto-components/produtos-arquivados/produtos-arquivados.component.html
// module id = ../../../../../src/app/components/produto-components/produtos-arquivados/produtos-arquivados.component.html
// module chunks = main